<template>
  <div id="skuRelation">
    <div class="filterConditionContainer">
      <el-card class="box-card">
        <div class="filterCondition" >
          <div class="searchIcon">
            <i class="el-icon-search"></i>
          </div>
          <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
            <el-form-item label="SKU" >
              <el-input v-model="filterForm.sku" :placeholder="$t('skuRelation.enterSKU')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('skuRelation.looks')" >
              <el-input v-model="filterForm.looks" :placeholder="$t('skuRelation.enterLooks')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('skuRelation.file')" >
              <el-select v-model="filterForm.file" :placeholder="$t('skuRelation.chooseFile')">
                <el-option
                  v-for="item in fileOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('skuRelation.importDate')" >
              <el-date-picker
                style="width: 100%"
                v-model="filterForm.importDate"
                type="date"
                :placeholder="$t('skuRelation.chooseImportDate')"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <div class="filterBtns">
                <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="filterBtns filterBtnsRight">
                <input type="file" ref="importData" @change="importData" id="importFileInput">
                <el-button type="primary" @click="openImport">{{ $t('skuRelation.import') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div class="tableContainer">
      <el-card class="box-card">
        <div class="tableBox">
          <div class="orangeIcon">
            <i class="el-icon-s-order"></i>
          </div>
          <el-button class="deleteBtn" type="primary" @click="patchDelete()">{{ $t('sourceMaterial.patchDelete') }}</el-button>
        </div>
        <div style="margin-top: 20px">
          <el-table
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
            >
            </el-table-column>
            <el-table-column
              prop="looks"
              :label="$t('skuRelation.looks')"
            >
            </el-table-column>
            <el-table-column
              prop="file"
              :label="$t('skuRelation.file')"
            >
            </el-table-column>
            <el-table-column
              prop="importDate"
              :label="$t('skuRelation.importDate')"
            >
            </el-table-column>

            <el-table-column
              fixed="right"
              :label="$t('operation')"
              width="120">
              <template slot-scope="scope">
                <el-button @click="deleteSku(scope.row.id)" type="text" size="small">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagingBox">
            <el-pagination
              background
              @current-change="currentChange"
              :current-page="tableConfig.current"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog
      :title="$t('skuRelation.import')"
      :visible.sync="importDialogVisible"
      width="40%"
      center
    >
      <el-form ref="form" :model="importForm" label-width="100px">
        <el-form-item :label="$t('skuRelation.file')">
          <el-select
            v-model="importForm.file"
            :placeholder="$t('skuRelation.chooseFile')"
            style="width: 100%"
          >
            <el-option
              v-for="item in fileOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmImport">{{ $t('confirm') }}</el-button>
        <el-button type="primary" @click="importDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Cookies from 'js-cookie'
import PickDoor from '../../components/pickDoor'
export default {
  name: 'Store',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      importForm: {
        file: '', // 所属文件夹
      },
      importDialogVisible: false,
      fileOptions: [], // 所属文件夹
      multipleSelection: [],
      initFilterForm: {
        sku: '',
        looks: '',
        file: '',
        importDate: ''
      },
      filterForm: {},
      tableData: [
        {
          sku: '111',
          looks: '222',
          importDate: '2020-09-09',
          file: '所属文件夹',
          id: '1'
        }
      ],
      tableConfig: {
        current: 1,
        size: 10
      },
      total: 0
    }
  },
  mounted () {
    this.onReset()
  },
  computed: {
  },
  methods: {
    openImport: function() {
      this.importDialogVisible = true
    },
    confirmImport: function() {
      this.importDialogVisible = false
      if (!this.importForm.file) {
        this.$message.warning('请选择所属文件夹')
      } else {
        this.$refs.importData.click()
      }
    },
    patchDelete: function() {
      // todo: 批量删除
      console.log('multipleSelection', this.multipleSelection)
      const ids = []
      _.each(this.multipleSelection, (selection) => {
        ids.push(selection.id)
      })
      console.log('ids', ids)
    },

    deleteSku: function(id) {
      // todo: 删除sku
    },

    importData: async function ({ target }) {
      // todo: 导入关系表
      // todo: 需要添加参数,所属文件夹
      let formData = new FormData()
      formData.append('file', target.files[0])
      let res = await window.instance.post(window.surveyUrl + '/door/import', formData)
      document.getElementById('importFileInput').value = ''
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
      }
    },

    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      const params = this.$tool.formatArrayToString(this.filterForm)
      let res = await this.$api.survey_api.listDoor(_.assign(params, this.tableConfig))
      this.tableData = res.list
      this.total = res.total
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    currentChange: function (index) {
      this.tableConfig.current = index
      this.onSearch(false)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
}
</script>

<style lang="sass" scoped>
  a
    margin-left: 10px
  .filterConditionContainer
    margin: 40px 20px 20px 20px
  .tableContainer
    margin: 40px 20px
  input[type=file]
    display: none
  .deleteBtn
    position: absolute
    top: 0
    right: 0
</style>



// WEBPACK FOOTER //
// src/pages/wo/skuRelationManage.vue